class InputError {
    static show(errors) {
        for (var key in errors){
            $('input[name="' + key + '"],textarea[name="' + key + '"]')
                .parent()
                .removeClass('form-validated')
                .addClass('form-error')
                .find('.invalid-feedback')
                .show()
                .html(errors[key][0]);
            $('select[name="' + key + '"]')
                .closest('.form-group')
                .removeClass('form-validated')
                .addClass('form-error')
                .find('.invalid-feedback')
                .show()
                .html(errors[key][0]);
        }
    }

    static reset() {
        $('.invalid-feedback').hide().parent().removeClass('form-error');
    }
    
    static validate() {
        $('.invalid-feedback').hide().parent().addClass('form-validated');
    }
}

export default InputError;